export default __webpack_public_path__ + "img/cttgrDBC.aec9d02c.svg";